import { StandardStateTypes, StandardActionTypes } from "./Standard.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StandardStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState(null),
};

const StandardReducer = (
  state: StandardStateTypes = INITIAL_STATE,
  action: any
): StandardStateTypes => {
  switch (action.type) {
    case StandardActionTypes.FETCH_ALL_STANDARD:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StandardActionTypes.FETCH_ALL_STANDARD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StandardActionTypes.FETCH_ALL_STANDARD_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StandardActionTypes.FETCH_ALL_STANDARD_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case StandardActionTypes.FETCH_ONE_STANDARD:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case StandardActionTypes.FETCH_ONE_STANDARD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StandardActionTypes.FETCH_ONE_STANDARD_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StandardActionTypes.FETCH_ONE_STANDARD_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StandardReducer;
